/**
 * A failed turn as the web shows it, built from the run's `RUN_ERROR`: its `code` and `message`, and the
 * `tool` from its metadata. Client-owned; the wire shapes are `RunErrorEvent` (@ag-ui/core) and `RunErrorMetadata`.
 */
export interface AssistantError {
    code?: string | null;
    message?: string | null;
    tool?: string | null;
}

/**
 * Known assistant error codes. Each maps to an `errors.<code>` translation key in `shared.json`; unknown
 * codes fall back to the backend-provided `message`.
 */
export const AssistantErrorCodes = {
    modelProviderUnavailable: "model_provider_unavailable",
    toolExecutionFailed: "tool_execution_failed",
    resumeInProgress: "resume_in_progress",
    unknown: "unknown"
} as const;

/**
 * Builds the translation key for a tool's user-friendly label. Every `FunctionName`
 * has a matching `toolNames.<name>` entry in `shared.json`; if a label is missing
 * (e.g. a tool AI Core reports that isn't synced into the schema yet), callers fall
 * back to the raw tool name. `tool` is typed as `string` to mirror that runtime reality.
 */
export const getToolNameKey = (tool: string): string => `toolNames.${tool}`;
